import React from 'react';
import { Box, Typography, Divider } from '@mui/material';

type HeadingProps = {
  children: React.ReactNode;
  styles?: {
    mt: number;
    mb: number;
  };
};

const Heading = ({ children, styles = { mt: 3, mb: 2 } }: HeadingProps) => (
  <Box mt={styles.mt} mb={styles.mb} width="100%">
    <Typography variant="h6" data-testid="heading">
      {children}
    </Typography>
    <Divider />
  </Box>
);

export default Heading;
